export default __webpack_public_path__ + "static/media/(68).cb1454c6.jpg";